import { Container, NineSliceSprite, Text, Texture } from "pixi.js";
import { BitmapTextStyles, getScm, SMALL_BTN_HEIGHT, tween } from "../../logic";
import { Button } from "../../prefabs";
import { IPoint } from "../../shared/IPoint";
import { IServerNotification } from "../../shared/IServerNotification";

const width = 400;
const padding = 10;
const btnSize = SMALL_BTN_HEIGHT;
const styleTitle = { ...BitmapTextStyles.LabelCaptionStyle, fontSize: 28, fill: 0xff5500, wordWrap: true, wordWrapWidth: width - 2 * padding - btnSize };
const styleMessage = { ...BitmapTextStyles.LabelTextStyle, fontSize: 24, fill: 0xffff00, wordWrap: true, wordWrapWidth: width - 2 * padding };

export class Notification extends Container {
    private sceneManager = getScm();
    private closeBtn!: Button;

    private handle: ReturnType<typeof setTimeout> | undefined;

    constructor(private payload: IServerNotification,
            private startingPosition?: IPoint, 
            tweenDurationMilliseconds: number = 2500, 
            notificationDurationSeconds: number = 10) {
        super();
        this.setup();
        tween(this).to({ x: getScm().Application.screen.width - width - 10, y: 10 }, tweenDurationMilliseconds).start();
        this.handle = setTimeout(() => {
            this.closeBtn.performClick(new Event('close'));
        }, notificationDurationSeconds * 1000);
    }

    private setup(): void {
        if (!this.startingPosition) {
            this.startingPosition = {
                x: this.sceneManager.Renderer.screen.width - width - padding,
                y: this.sceneManager.Renderer.screen.height - 200 - padding
            };
        }
        this.position.set(this.startingPosition.x, this.startingPosition.y);

        //-------------------------------
        //  dialog box background
        //-------------------------------
        var bg = new NineSliceSprite({
            texture: Texture.from("/assets/gui/panel-border.png"),
            leftWidth: 3,
            topHeight: 3,
            rightWidth: 3,
            bottomHeight: 3,
        });
        bg.width = width;
        this.addChild(bg);

        //----------------------------
        //  dialog close button
        //----------------------------        
        const texture = Texture.from("/assets/gui/btn-close.png");
        texture.source.scaleMode = "nearest";
        this.closeBtn = new Button(
            {
                textureName: "/assets/gui/btn-close.png",
                ltrbSize: 0,
                width: btnSize,
                height: btnSize,
                x: width - btnSize - 3,
                y: 4,
                onClick: () => {
                    if (this.handle) {
                        clearTimeout(this.handle);
                        this.handle = undefined;
                        tween(this)
                            .to({ y: this.height }, 200)
                            .start();
                    }
                    tween(this)
                        .to({ x: this.sceneManager.Renderer.screen.width, alpha: 0.5 }, 500)
                        .onComplete(() => this.sceneManager.MasterHudOverlay.removeChild(this))
                        .start();
                },
            },
        );
        this.addChild(this.closeBtn);
        
        const txtTime = new Text({
            text: new Date().toLocaleTimeString(),
            style: styleMessage,
            x: padding,
            y: padding,
        });
        this.addChild(txtTime);
        
        const txtTitle = new Text({
            text: this.payload.title,
            style: styleTitle,
            x: txtTime.x + txtTime.width + padding,
            y: padding,
        });
        this.addChild(txtTitle);

        const txtMessage = new Text({
            text: this.payload.message,
            style: styleMessage,
            x: txtTime.x,
            y: txtTime.y + txtTime.height + padding,
        });

        this.addChild(txtMessage);
        bg.height = 2 * padding + txtMessage.y + txtMessage.height;
    }
}